import React, { Fragment } from 'react'

import { YourIncomeAndPropertiesStep } from './YourIncomeAndPropertiesStep'
import { YourExpensesAndLiabilitiesStep } from './YourExpensesAndLiabilitiesStep'
import { CreditReportStep } from './CreditReportStep'
import { ApplicantApprovalStep } from '../ApplicantApprovalStep'
import {
  makeCreditReportStepId,
  makeExpensesAndLiabilitiesStepId,
  makeIncomeAndAssetsStepId,
  makeApplicantApprovalStepId,
} from '../utils'

function YourFinancialsSteps({ sharedProps }) {
  return sharedProps.map((props, idx) => (
    <Fragment key={idx}>
      <CreditReportStep {...props} stepId={makeCreditReportStepId(idx)} />
      <YourIncomeAndPropertiesStep {...props} stepId={makeIncomeAndAssetsStepId(idx)} />
      <YourExpensesAndLiabilitiesStep
        {...props}
        stepId={makeExpensesAndLiabilitiesStepId(idx)}
      />
      <ApplicantApprovalStep
        {...props}
        stepId={makeApplicantApprovalStepId(idx)}
        index={idx}
      />
    </Fragment>
  ))
}

export { YourFinancialsSteps }
